import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function Gallery() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const categories = [
    { id: 'all', name: 'All Photos', icon: 'ri-gallery-line' },
    { id: 'projects', name: 'Our Projects', icon: 'ri-building-line' },
    { id: 'products', name: 'Sanitary Items', icon: 'ri-store-2-line' },
    { id: 'shop', name: 'Our Shop', icon: 'ri-home-4-line' }
  ];

  const images = [
    // Projects
    {
      category: 'projects',
      title: 'Luxury Bathroom Installation',
      description: 'Complete bathroom renovation with premium fixtures',
      image: 'https://public.readdy.ai/ai/img_res/f7b2d1525e1e7f7b8e96f94c2fe7d055.jpg'
    },
    {
      category: 'projects',
      title: 'Kitchen Plumbing Work',
      description: 'Professional kitchen sink and tap installation',
      image: 'https://readdy.ai/api/search-image?query=modern%20kitchen%20with%20stainless%20steel%20sink%20and%20chrome%20faucet%20installed%2C%20clean%20countertop%2C%20professional%20plumbing%20work%2C%20completed%20kitchen%20installation%20project&width=800&height=600&seq=proj2&orientation=landscape'
    },
    {
      category: 'projects',
      title: 'Commercial Bathroom Project',
      description: 'Large-scale commercial bathroom installation',
      image: 'https://readdy.ai/api/search-image?query=commercial%20bathroom%20with%20multiple%20fixtures%20installed%2C%20modern%20sanitary%20ware%2C%20professional%20tiling%20work%2C%20large%20scale%20plumbing%20project%2C%20clean%20professional%20finish&width=800&height=600&seq=proj3&orientation=landscape'
    },
    {
      category: 'projects',
      title: 'Residential Plumbing',
      description: 'Complete house plumbing system installation',
      image: 'https://readdy.ai/api/search-image?query=residential%20plumbing%20pipes%20installation%2C%20UPVC%20and%20PPRC%20pipes%20fitted%20in%20walls%2C%20professional%20plumbing%20work%20in%20progress%2C%20organized%20pipe%20layout%2C%20construction%20site&width=800&height=600&seq=proj4&orientation=landscape'
    },
    {
      category: 'projects',
      title: 'Shower Cabin Installation',
      description: 'Glass shower enclosure with modern fixtures',
      image: 'https://readdy.ai/api/search-image?query=modern%20glass%20shower%20cabin%20installed%20in%20bathroom%2C%20chrome%20fixtures%2C%20rainfall%20shower%20head%2C%20professional%20installation%2C%20elegant%20bathroom%20design%2C%20completed%20project&width=800&height=600&seq=proj5&orientation=landscape'
    },
    {
      category: 'projects',
      title: 'Bathroom Renovation',
      description: 'Complete bathroom makeover with new fittings',
      image: 'https://readdy.ai/api/search-image?query=renovated%20bathroom%20with%20new%20sanitary%20fixtures%2C%20modern%20toilet%20and%20basin%2C%20chrome%20taps%2C%20clean%20white%20tiles%2C%20professional%20renovation%20work%20completed&width=800&height=600&seq=proj6&orientation=landscape'
    },

    // Sanitary Products
    {
      category: 'products',
      title: 'Premium Bathroom Taps',
      description: 'Chrome-plated taps and mixers collection',
      image: 'https://readdy.ai/api/search-image?query=collection%20of%20chrome%20bathroom%20taps%20and%20faucets%20displayed%20on%20shelf%2C%20various%20designs%2C%20modern%20sanitary%20fixtures%2C%20showroom%20display%2C%20professional%20product%20photography&width=800&height=600&seq=prod30&orientation=landscape'
    },
    {
      category: 'products',
      title: 'Shower Systems',
      description: 'Complete shower sets and accessories',
      image: 'https://readdy.ai/api/search-image?query=shower%20systems%20and%20rainfall%20heads%20displayed%20in%20showroom%2C%20chrome%20fixtures%2C%20modern%20bathroom%20accessories%2C%20professional%20product%20display%2C%20sanitary%20ware%20collection&width=800&height=600&seq=prod31&orientation=landscape'
    },
    {
      category: 'products',
      title: 'Kitchen Sinks Collection',
      description: 'Stainless steel sinks in various sizes',
      image: 'https://readdy.ai/api/search-image?query=stainless%20steel%20kitchen%20sinks%20displayed%20in%20showroom%2C%20various%20sizes%20and%20designs%2C%20modern%20kitchen%20fixtures%2C%20professional%20product%20display%2C%20sanitary%20ware%20store&width=800&height=600&seq=prod32&orientation=landscape'
    },
    {
      category: 'products',
      title: 'Toilet Accessories',
      description: 'WC seats, flush tanks, and fittings',
      image: 'https://readdy.ai/api/search-image?query=toilet%20accessories%20and%20WC%20seats%20displayed%20on%20shelves%2C%20flush%20tanks%2C%20bathroom%20fittings%2C%20organized%20showroom%20display%2C%20sanitary%20products%20collection&width=800&height=600&seq=prod33&orientation=landscape'
    },
    {
      category: 'products',
      title: 'Pipes and Fittings',
      description: 'UPVC and PPRC pipes with accessories',
      image: 'https://readdy.ai/api/search-image?query=UPVC%20and%20PPRC%20pipes%20stacked%20neatly%20with%20fittings%2C%20elbows%20and%20connectors%2C%20plumbing%20supplies%20organized%20in%20store%2C%20professional%20product%20display&width=800&height=600&seq=prod34&orientation=landscape'
    },
    {
      category: 'products',
      title: 'Hardware Tools',
      description: 'Plumbing tools and accessories',
      image: 'https://readdy.ai/api/search-image?query=plumbing%20tools%20and%20hardware%20displayed%20on%20wall%2C%20wrenches%20pliers%20and%20accessories%2C%20organized%20tool%20display%2C%20professional%20hardware%20store%2C%20sanitary%20supplies&width=800&height=600&seq=prod35&orientation=landscape'
    },

    // Shop Photos
    {
      category: 'shop',
      title: 'Malik Brothers Showroom',
      description: 'Our main showroom in Range Road',
      image: 'https://readdy.ai/api/search-image?query=modern%20sanitary%20showroom%20exterior%20with%20Malik%20Brothers%20signboard%2C%20professional%20shop%20front%2C%20Range%20Road%20Rawalpindi%2C%20clean%20organized%20store%20entrance%2C%20business%20storefront&width=800&height=600&seq=shop1&orientation=landscape'
    },
    {
      category: 'shop',
      title: 'Product Display Area',
      description: 'Well-organized product sections',
      image: 'https://readdy.ai/api/search-image?query=sanitary%20showroom%20interior%20with%20products%20displayed%20on%20shelves%2C%20organized%20sections%2C%20bathroom%20fixtures%2C%20kitchen%20items%2C%20professional%20retail%20environment%2C%20bright%20lighting&width=800&height=600&seq=shop2&orientation=landscape'
    },
    {
      category: 'shop',
      title: 'Customer Service Area',
      description: 'Friendly staff ready to assist',
      image: 'https://readdy.ai/api/search-image?query=sanitary%20shop%20counter%20with%20staff%20helping%20customers%2C%20professional%20service%20area%2C%20product%20catalogs%2C%20friendly%20business%20environment%2C%20retail%20store%20interior&width=800&height=600&seq=shop3&orientation=landscape'
    },
    {
      category: 'shop',
      title: 'Stock Room',
      description: 'Well-stocked inventory',
      image: 'https://readdy.ai/api/search-image?query=warehouse%20storage%20with%20sanitary%20products%20stocked%20on%20shelves%2C%20organized%20inventory%2C%20plumbing%20supplies%2C%20pipes%20and%20fittings%2C%20professional%20stock%20management&width=800&height=600&seq=shop4&orientation=landscape'
    },
    {
      category: 'shop',
      title: 'Bathroom Fixtures Section',
      description: 'Premium sanitary ware display',
      image: 'https://readdy.ai/api/search-image?query=bathroom%20fixtures%20section%20in%20showroom%2C%20taps%20showers%20and%20accessories%20displayed%20beautifully%2C%20modern%20sanitary%20ware%2C%20professional%20product%20presentation%2C%20retail%20display&width=800&height=600&seq=shop5&orientation=landscape'
    },
    {
      category: 'shop',
      title: 'Kitchen Section',
      description: 'Kitchen sinks and faucets area',
      image: 'https://readdy.ai/api/search-image?query=kitchen%20section%20in%20sanitary%20showroom%2C%20stainless%20steel%20sinks%20and%20faucets%20displayed%2C%20organized%20product%20area%2C%20professional%20retail%20environment%2C%20modern%20fixtures&width=800&height=600&seq=shop6&orientation=landscape'
    }
  ];

  const filteredImages = selectedCategory === 'all' 
    ? images 
    : images.filter(img => img.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <WhatsAppButton />

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-orange-600 to-orange-500 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">Our Gallery</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Explore our completed projects, product collection, and showroom
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-12 bg-gray-50 sticky top-0 z-10 shadow-md">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setSelectedCategory(cat.id)}
                className={`px-6 py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer flex items-center gap-2 ${
                  selectedCategory === cat.id
                    ? 'bg-orange-600 text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:bg-orange-50 border-2 border-gray-200'
                }`}
              >
                <i className={`${cat.icon} text-xl`}></i>
                {cat.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredImages.map((item, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl shadow-md hover:shadow-2xl transition-all overflow-hidden group cursor-pointer"
                onClick={() => setSelectedImage(item.image)}
              >
                <div className="overflow-hidden relative">
                  <img 
                    src={item.image} 
                    alt={item.title}
                    className="w-full h-72 object-cover object-top group-hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-all flex items-center justify-center">
                    <i className="ri-zoom-in-line text-white text-4xl opacity-0 group-hover:opacity-100 transition-all"></i>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2 text-gray-800">{item.title}</h3>
                  <p className="text-gray-600">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button 
            className="absolute top-4 right-4 w-12 h-12 flex items-center justify-center bg-white rounded-full text-gray-800 hover:bg-gray-200 transition-all cursor-pointer"
            onClick={() => setSelectedImage(null)}
          >
            <i className="ri-close-line text-2xl"></i>
          </button>
          <img 
            src={selectedImage} 
            alt="Gallery"
            className="max-w-full max-h-full object-contain rounded-lg"
          />
        </div>
      )}

      {/* CTA Section */}
      <section className="py-20 bg-orange-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">Want to See More?</h2>
          <p className="text-xl mb-10 max-w-2xl mx-auto">
            Visit our showroom to explore our complete range of products and completed projects
          </p>
          <a 
            href="https://wa.me/923135224547" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-white hover:bg-gray-100 text-orange-600 px-10 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Contact Us on WhatsApp
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
